module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lDxfC"))).then(() => module.bundle.root('aVi2q'));